/**
 * Determines if a management system is required for the solar plant configuration
 * @param {Object} solarPlant - The solar plant configuration object
 * @returns {boolean} - True if management system is required, false otherwise
 */
export const management_system_required = (solarPlant) => {
  if (!solarPlant) return false;

  // Check inverter total power >= 7kW
  const inverterTotalPower = calculateInverterTotalPower(solarPlant.inverters);
  if (inverterTotalPower >= 7) return true;

  // Check solar panel total power >= 7kW
  const solarPanelTotalPower = calculateSolarPanelTotalPower(solarPlant.solarPanels);
  if (solarPanelTotalPower >= 7) return true;

  // Check if battery exists
  if (solarPlant.battery || solarPlant.batteryItem) return true;

  // Check if wallbox exists
  if (solarPlant.wallbox || solarPlant.wallboxItem) return true;

  return false;
};

/**
 * Calculates total power of all inverters in kW
 * @param {Array} inverters - Array of inverter objects
 * @returns {number} - Total power in kW
 */
const calculateInverterTotalPower = (inverters) => {
  if (!inverters || !Array.isArray(inverters)) return 0;

  return inverters.reduce((total, inverter) => {
    const power = inverter.item?.inverter?.nominalPower || 0;
    const count = parseInt(inverter.count || 0, 10);
    return total + power * count;
  }, 0);
};

/**
 * Calculates total power of all solar panels in kW
 * @param {Array} solarPanels - Array of solar panel objects
 * @returns {number} - Total power in kW
 */
const calculateSolarPanelTotalPower = (solarPanels) => {
  if (!solarPanels || !Array.isArray(solarPanels)) return 0;

  return solarPanels.reduce((total, panel) => {
    const power = panel.item?.solarPanel?.power || 0;
    const count = parseInt(panel.count || 0, 10);
    return total + (power / 1000) * count; // Convert W to kW
  }, 0);
};
